import { useContext } from "react"
import MainContext from "../contextApi/MainContext"


export const useMain=()=>{
    return useContext(MainContext);
}